/* eslint-disable */
import React, { Component, createRef } from 'react';
import ReactGA from 'react-ga';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { isMobile  } from 'react-device-detect';
import JP_HEADER_124 from '../../sections/JP_Header_124/JP_Header';
import JP_PROGRAMCRITERIA_155 from '../../sections/JP_ProgramCriteria_155/JP_ProgramCriteria';
import JP_PROGRAMDESCRIPTION_156 from '../../sections/JP_ProgramDescription_156/JP_ProgramDescription';
import JP_FOOTER_123 from '../../sections/JP_Footer_123/JP_Footer';

function withParams(Component) {
    return props => <Component {...props} params={useParams()} />;
}

class project1 extends Component {
   constructor(props) {
       super(props);
       this.state = {
           currentPage: null,
           currentSection: null,
           override: true,
           section: [
               { id: 1, slug: localStorage.getItem('language') === "English"? 'header' : 'header'},
               { id: 2, slug: localStorage.getItem('language') === "English"? 'program-criteria' : 'program-criteria'},
               { id: 3, slug: localStorage.getItem('language') === "English"? 'program-description' : 'program-description'},
               { id: 4, slug: localStorage.getItem('language') === "English"? 'footer' : 'footer'},
           ],
       };
       this.scrollToSection = this.scrollToSection.bind(this);
       this.scrollAction = this.scrollAction.bind(this);
        this.isStateChanging = false
   }
   componentDidMount() {
       this.scrollToSection();
       ReactGA.initialize('G-SR612FXX85')
       ReactGA.pageview(window.location.pathname + window.location.search);
   }
   componentWillUnmount(){
   }
   section1 = createRef()
   section2 = createRef()
   section3 = createRef()
   section4 = createRef()
   scrollToSection() {
       let currentLocation = window.location.href
       const hasSectionAnchor = currentLocation.includes('/#')
       if (hasSectionAnchor) {
           let anchorSectionId = `${currentLocation.substring(currentLocation.indexOf('#') + 1)}`
           setTimeout(() => { this.scrollAction(anchorSectionId) }, 1000)
       }
   }
   scrollAction(anchorSectionId) {
       const uri_dec = decodeURIComponent(anchorSectionId)
       const key = this.state.section.filter(x => x.slug == uri_dec).map(obj => `section${obj.id}`)
       const getY = (element) => element.getBoundingClientRect().top + window.pageYOffset - 140;
       if (key) {
          if (key[0] === 'section1') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section1.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section2') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section2.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section3') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section3.current), behavior: 'smooth' })}, 1000)
          } else if (key[0] === 'section4') {
               setTimeout(() => {window.scrollTo({ top: getY(this.section4.current), behavior: 'smooth' })}, 1000)
            }
       }
   }
   render() {
       const getHelmetTitle = () => {
           var title;
           switch (localStorage.getItem('language')) {
               case 'English':
                   title = <title> Program Criteria and Description | Jawa Power</title>;
                   break;
               case 'Indonesian':
                   title = <title> Program Criteria and Description | Jawa Power</title>;
                   break;
               case 'Vietnamese':
                   title = <title> Social Responsibility | Jawa Power</title>;
                   break;
               case 'Thai':
                   title = <title> Social Responsibility | Jawa Power</title>;
                   break;
               case 'French':
                   title = <title> Social Responsibility | Jawa Power</title>;
                   break;
               case 'Norwegian':
                   title = <title> Social Responsibility | Jawa Power</title>;
                   break;
               default:
                   title = <title> Program Criteria and Description | Jawa Power</title>;
                   break;
           }
           return title;
       };
       const getHelmetDescription = () => {
           var description;
           switch (localStorage.getItem('language')) {
               case 'English':
                   description = <meta name='description' content='Program Criteria and Description' />;
                   break;
               case 'Indonesian':
                   description = <meta name='description' content='Program Criteria and Description' />;
                   break;
               case 'Vietnamese':
                   description = <meta name='description' content='None' />;
                   break;
               case 'Thai':
                   description = <meta name='description' content='None' />;
                   break;
               case 'French':
                   description = <meta name='description' content='None' />;
                   break;
               case 'Norwegian':
                   description = <meta name='description' content='None' />;
                   break;
               default:
                   description = <meta name='description' content='Program Criteria and Description' />;
                   break;
           }
           return description;
       };
       const getHelmetKeywords = () => {
           var keywords;
           switch (localStorage.getItem('language')) {
               case 'English':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Indonesian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Vietnamese':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Thai':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'French':
                   keywords = <meta name='keywords' content='' />;
                   break;
               case 'Norwegian':
                   keywords = <meta name='keywords' content='' />;
                   break;
               default:
                   keywords = <meta name='keywords' content='' />;
                   break;
           }
           return keywords;
       };
         let helmet = getHelmetTitle();
         let description = getHelmetDescription();
         let keywords = getHelmetKeywords();
       return (
           <>
               <Helmet>
                   {helmet}
                   {description}
                   {keywords}
               </Helmet>
            <div ref={this.section1}>
                <JP_HEADER_124 />
            </div>
            <div ref={this.section2}>
                <JP_PROGRAMCRITERIA_155 />
            </div>
            <div ref={this.section3}>
                <JP_PROGRAMDESCRIPTION_156 />
            </div>
            <div ref={this.section4}>
                <JP_FOOTER_123 />
            </div>
           </>
       );
   }
}
export default withParams(project1);